const Report = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-load" */ '@/pages/base-info/order-properties/load/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-load" */ '@/pages/base-info/order-properties/load/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-load" */ '@/pages/base-info/order-properties/load/edit.vue'
  )

export default {
  path: 'load',
  meta: {
    label: 'load',
    auth: 'load'
  },
  component: {
    name: 'Load',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoOrderPropertiesLoad',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'BaseInfoCreateOrderPropertiesLoad',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'BaseInfoEditOrderPropertiesLoad',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
